import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createStakeholderRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('../layouts/layout-stakeholder-root.vue'),
      props: true,
      redirect: () => ({
        name: routeDefinitions.stakeholders.overview
      }),
      children: [
        {
          path: 'overview',
          component: () => import('../layouts/layout-stakeholder-search.vue'),
          props: true,
          children: [
            {
              path: '',
              name: routeDefinitions.stakeholders.overview,
              component: () =>
                import('../views/view-stakeholders-overview.vue'),
              props: true
            }
          ]
        },
        {
          path: 'clients',
          children: [
            {
              path: 'create',
              component: () =>
                import('../layouts/layout-stakeholder-create.vue'),
              props: ({ params }) => ({
                stakeholderType: 'client'
              }),
              children: [
                {
                  path: '',
                  name: routeDefinitions.stakeholders.clientCreate,
                  component: () =>
                    import(
                      '../components/providers/create-stakeholder-provider/forms/create-stakeholder-form.vue'
                    ),
                  props: ({ params }) => ({
                    stakeholderType: 'client'
                  })
                }
              ]
            },
            {
              path: ':id',
              component: () => import('../layouts/layout-stakeholder.vue'),
              props: ({ params }) => ({
                id: params.id,
                stakeholderType: 'client'
              }),
              children: [
                {
                  path: '',
                  name: routeDefinitions.stakeholders.client.general,
                  component: () =>
                    import('../views/view-stakeholder-general.vue'),
                  props: true
                },
                {
                  path: 'billing',
                  name: routeDefinitions.stakeholders.client.billing,
                  component: () =>
                    import('../views/view-stakeholder-billing.vue'),
                  props: true
                },
                {
                  path: 'contacts',
                  name: routeDefinitions.stakeholders.client.contacts,
                  component: () =>
                    import('../views/view-stakeholder-contacts.vue'),
                  props: true
                },
                {
                  path: 'danger-zone',
                  name: routeDefinitions.stakeholders.client.dangerZone,
                  component: () =>
                    import('../views/view-stakeholder-danger-zone.vue'),
                  props: true
                }
              ]
            }
          ]
        },
        {
          path: 'vendors',
          children: [
            {
              path: 'create',
              component: () =>
                import('../layouts/layout-stakeholder-create.vue'),
              props: ({ params }) => ({
                stakeholderType: 'vendor'
              }),
              children: [
                {
                  path: '',
                  name: routeDefinitions.stakeholders.vendorCreate,
                  component: () =>
                    import(
                      '../components/providers/create-stakeholder-provider/forms/create-stakeholder-form.vue'
                    ),
                  props: ({ params }) => ({
                    stakeholderType: 'vendor'
                  })
                }
              ]
            },
            {
              path: ':id',
              component: () => import('../layouts/layout-stakeholder.vue'),
              props: ({ params }) => ({
                id: params.id,
                stakeholderType: 'vendor'
              }),
              children: [
                {
                  path: '',
                  name: routeDefinitions.stakeholders.vendor.general,
                  component: () =>
                    import('../views/view-stakeholder-general.vue'),
                  props: true
                },
                {
                  path: 'contacts',
                  name: routeDefinitions.stakeholders.vendor.contacts,
                  component: () =>
                    import('../views/view-stakeholder-contacts.vue'),
                  props: true
                },
                {
                  path: 'danger-zone',
                  name: routeDefinitions.stakeholders.vendor.dangerZone,
                  component: () =>
                    import('../views/view-stakeholder-danger-zone.vue'),
                  props: true
                }
              ]
            }
          ]
        },
        {
          path: 'other-parties',
          children: [
            {
              path: 'create',
              component: () =>
                import('../layouts/layout-stakeholder-create.vue'),
              props: ({ params }) => ({
                stakeholderType: 'other'
              }),
              children: [
                {
                  path: '',
                  name: routeDefinitions.stakeholders.otherPartyCreate,
                  component: () =>
                    import(
                      '../components/providers/create-stakeholder-provider/forms/create-stakeholder-form.vue'
                    ),
                  props: ({ params }) => ({
                    stakeholderType: 'other'
                  })
                }
              ]
            },
            {
              path: ':id',
              component: () => import('../layouts/layout-stakeholder.vue'),
              props: ({ params }) => ({
                id: params.id,
                stakeholderType: 'other'
              }),
              children: [
                {
                  path: '',
                  name: routeDefinitions.stakeholders.other.general,
                  component: () =>
                    import('../views/view-stakeholder-general.vue'),
                  props: true
                },
                {
                  path: 'contacts',
                  name: routeDefinitions.stakeholders.other.contacts,
                  component: () =>
                    import('../views/view-stakeholder-contacts.vue'),
                  props: true
                },
                {
                  path: 'danger-zone',
                  name: routeDefinitions.stakeholders.other.dangerZone,
                  component: () =>
                    import('../views/view-stakeholder-danger-zone.vue'),
                  props: true
                }
              ]
            }
          ]
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
